import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { AuthShell } from "@/components/AuthShell";
import { Field } from "@/components/common";
import { HelpTip } from "@/components/HelpTip";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", business_name: "", email: "", password: "", license_code: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await register(f);
      toast.success("Licença ativada! Vamos configurar seu negócio.");
      nav("/onboarding");
    } catch (err) { setError(errMsg(err)); } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Ativar licença" subtitle="Use o código de ativação recebido após a compra para criar sua conta."
      footer={<>Já tem conta? <Link to="/login" data-testid="link-login" className="text-primary font-medium hover:underline">Entrar</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <Field label="Código de ativação" help={<HelpTip title="Código de ativação" testId="help-license">Você recebe esse código por e-mail após comprar a licença (Hotmart/Kiwify). Ele só pode ser usado uma vez.</HelpTip>}>
          <Input data-testid="register-license" required value={f.license_code} onChange={set("license_code")} placeholder="PEDRADA-0001" className="num uppercase" />
        </Field>
        <div className="grid sm:grid-cols-2 gap-4">
          <Field label="Seu nome"><Input data-testid="register-name" required value={f.name} onChange={set("name")} placeholder="Maria" /></Field>
          <Field label="Nome do negócio"><Input data-testid="register-business" value={f.business_name} onChange={set("business_name")} placeholder="Burger da Maria" /></Field>
        </div>
        <Field label="E-mail"><Input data-testid="register-email" type="email" required value={f.email} onChange={set("email")} placeholder="voce@restaurante.com" /></Field>
        <Field label="Senha (mín. 6 caracteres)"><PasswordInput data-testid="register-password" required minLength={6} value={f.password} onChange={set("password")} /></Field>
        {error && <p data-testid="register-error" className="text-sm text-rose-500 bg-rose-500/10 rounded-lg px-3 py-2">{error}</p>}
        <Button data-testid="register-submit" type="submit" className="w-full h-11 rounded-xl font-semibold" disabled={loading}>{loading ? "Ativando..." : "Criar conta e ativar"}</Button>
      </form>
    </AuthShell>
  );
}
